module.exports = __webpack_public_path__ + "static/img/queen.c981f8c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/queen.gif
// module id = Bkts
// module chunks = 1